<template>
	<span ref="loadMoreData" class="load-more-data" />
</template>

<script>
export default {
	name: 'LoadMore',

	mounted() {
		this.observeLoadMore()
	},

	beforeDestroy() {
		this.observer && this.observer.disconnect()
	},

	methods: {
		observeLoadMore() {
			if (this.$refs && this.$refs.loadMoreData) {
				this.observer = new IntersectionObserver(
					entries => {
						const ent = entries[0]
						ent.intersectionRatio > 0 && this.$emit('load-more')
					},
					{ threshold: [0] }
				)
				this.observer.observe(this.$refs.loadMoreData)
			}
		}
	}
}
</script>

<style lang="scss"></style>
